export function generateFilterQueryString(
  filters: Array<[string, unknown, boolean?, boolean?]>,
  date?: Record<string, unknown>,
): string {
  let filterQuery = "";

  if (filters.length) {
    filterQuery +=
      "&filter=" +
      encodeURIComponent(
        JSON.stringify(
          filters.map(([key, value, exact, not]) => ({
            key,
            value,
            exact,
            not,
          })),
        ),
      );
  }

  if (date) {
    filterQuery += "&date=" + JSON.stringify(date);
  }

  return filterQuery;
}
